import React from "react";
import PropTypes from "prop-types";
import Base from "./Base";
import Group from "./Group";

class Checkbox extends Base {
  static propTypes = {
    ...Base.propTypes,
    onValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.object,
      PropTypes.array
    ])
  };

  static defaultProps = {
    ...Base.defaultProps,
    onValue: true,
    offValue: false
  };

  onChange(event) {
    const value = event.target.checked
      ? this.props.onValue
      : this.props.offValue;
    this.setState({ value }, () => {
      if (this.isValid(this.state.value)) {
        this.props.onChange({ target: this, value: this.state.value });
      } else {
        this.props.onError({ target: this, value: this.state.value });
      }
    });
  }

  render() {
    const inputID = this.getInputID();
    return (
      <Group {...this.props} inputID={inputID} errors={this.state.errors}>
        <div style={{ display: "flex", alignItems: "center", columnGap: 8 }}>
          <label
            className="form-m__switch"
            htmlFor={inputID}
            style={{ margin: 0 }}
          >
            <input
              type="checkbox"
              id={inputID}
              name={this.getInputName()}
              className="form-m__switch-input"
              onBlur={this.onBlur}
              onFocus={this.onFocus}
              value={this.props.onValue}
              checked={
                this.applyFilters(this.props.onValue) ===
                this.applyFilters(this.state.value)
              }
              onChange={this.onChange}
              disabled={this.props.disabled}
              readOnly={this.props.readOnly}
            />
            <span className="form-m__switch-switcher" />
          </label>
          {this.props.children && (
            <span style={{ color: "#7f7f7f", fontSize: 15 }}>
              {this.props.children}
            </span>
          )}
        </div>
      </Group>
    );
  }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/Form/Input/Checkbox.js